function downloadFile (url) {
    var downloadLink = angular.element('<a></a>');

    downloadLink.attr('href', url.substring(1));
    downloadLink[0].click();
}